import { render, staticRenderFns } from "./StudentExaminationRoom.vue?vue&type=template&id=98bbff18&"
import script from "./StudentExaminationRoom.vue?vue&type=script&lang=js&"
export * from "./StudentExaminationRoom.vue?vue&type=script&lang=js&"
import style0 from "./StudentExaminationRoom.vue?vue&type=style&index=0&id=98bbff18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports